import { Component, OnInit } from '@angular/core';
import { ClientService } from '../services/client.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SearchPackage } from '../models/searchPackage';
import { Client } from '../models/clientLocation';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-package-list',
  templateUrl: './package-list.component.html',
  styleUrls: ['./package-list.component.less']
})
export class PackageListComponent implements OnInit {
  clientId : number;
  nonCraClients : Array<Client>;
  packages : Array<SearchPackage>;
  selectedClient : Client;
  constructor(public toast : ToastrService,public clientSrv : ClientService,public location : Router, public activatedRoute: ActivatedRoute, public auth: AuthService) { 
    this.auth.roleFetchComplete.subscribe((dta: any)=>{
      console.log('roles fetched');
      // TODO : pass the status code so know if we should actually redirect(401).
      if(dta.status == 401)this.location.navigateByUrl('/auth');
      else if(dta.status == 500) this.toast.error(`error ${dta}`);
  });
  }

  createPackage(){
    this.location.navigateByUrl("/packages/create/"+this.clientId);
  }
  
  public get error() : boolean {
    if(this.packages){
      return (this.packages == undefined || this.packages.length == 0);
    }
    else{
      return true;
    }
  }
  
  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(
      (params: ParamMap) =>{
        this.clientId = parseInt(params.get('client'),10);
        this.auth.postLoginRedirect = '/packages/list/'+this.clientId;
        if(!localStorage.getItem('STP-JWT')){
          this.auth.hasRedirect = true;
          this.location.navigateByUrl('/auth')
        }else {
          this.auth.GetUsersRoles();
          this.clientSrv.FetchClientSearchPackages(this.clientId).subscribe((results : any)=>{
            this.packages = results.map((v) => {
              v.searches = v.searches;
              return v;
            });
          });

          this.clientSrv.FetchClientList().subscribe((results : any)=>{
            this.nonCraClients = results;
            console.log(this.nonCraClients)
          });
        }
      });
  }

}
